import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { updatePassword } from 'api/users';
import Container from '@mui/material/Container';
import MKBox from 'components/MaterialKit/MKBox';
import { getErrorMessage } from 'utils/general';
import { withLoading } from 'utils/hoc';
import { getLocaleMap } from 'utils/locales';
import SetPasswordForm from './SetPasswordForm';

const SetPasswordSection = ({
  setLoading,
  title_color,
  title_font_size,
  title_font_weight,
  save_button_color,
  save_button_font_color,
  back_button_color,
  back_button_font_color,
 }) => {
  const [lm, setLm] = useState({});
  useEffect(() => {
    getLocaleMap(['labels_set_password', 'alerts_update_successfully'])
      .then((response) => {
        setLm(response);
      });
  }, []);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const userId = searchParams.get('username');

  const updatePasswordToApi = useCallback((values, { setFieldError }) => {
    const body = {
      password: values.password,
    };
    setLoading(true);
    return updatePassword(userId, body)
      .then(() => {
        alert(lm.alerts_update_successfully);
        navigate(-1);
      })
      .catch((err) => {
        setFieldError('form', getErrorMessage(err));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [setLoading, userId, lm.alerts_update_successfully, navigate]);

  return (
    <MKBox flex={1} py="2rem">
      <Container>
        <div style={{ marginBottom: 10, color: title_color, fontSize: title_font_size, fontWeight: title_font_weight }}>
          {lm.labels_set_password}
        </div>
        <SetPasswordForm
          onSave={updatePasswordToApi}
          saveButtonColor={save_button_color}
          saveButtonFontColor={save_button_font_color}
          backButtonColor={back_button_color}
          backButtonFontColor={back_button_font_color}
        />
      </Container>
    </MKBox>
  );
};

SetPasswordSection.propTypes = {
  setLoading: PropTypes.func,
  title_color: PropTypes.string,
  title_font_size: PropTypes.string,
  title_font_weight: PropTypes.string,
  save_button_color: PropTypes.string,
  save_button_font_color: PropTypes.string,
  back_button_color: PropTypes.string,
  back_button_font_color: PropTypes.string,
};

export default withLoading(SetPasswordSection);
